module.exports = __webpack_public_path__ + "static/media/azure-new.b43c6e5d.png";